import { Row, Col } from 'antd'
import { webAssets } from '../../../utils/webAssets'
import ResponsiveImage from '../ResponsiveImage'

import Crown from '../../svgs/aboutUs/Crown'

const AboutUsIntro = () => {
  return (
    <div
      className='about-us-intro py-80'
      style={{
        background:
          'linear-gradient(0deg, rgba(143, 192, 69, 0.00) 17.5%, rgba(143, 192, 69, 0.126) 100%)',
      }}
    >
      <div className='container mx-auto'>
        <Row align='top' gutter={[60, 0]}>
          <Col
            xs={{ order: 2, span: 24 }}
            lg={{ order: 1, span: 12 }}
            className='mt-24'
          >
            <h1 className='text-[2.5rem] lg:text-[3rem] leading-[3.5rem] lg:leading-[5rem] font-medium capitalize mb-24'>
              <span className='text-green font-bold'>SmartCAF</span> è il primo
              CAF completamente{' '}
              <span className='text-green font-bold'>online in Italia.</span>
            </h1>
            <p className='text-dimmed text-xl font-light leading-9 lg:w-11/12'>
              Siamo uniti dalla passione per il servizio e dalla determinazione
              nel rendere l&apos;assistenza fiscale un&apos;esperienza semplice
              e conveniente.
            </p>
          </Col>
          <Col xs={{ order: 1, span: 24 }} lg={{ order: 2, span: 12 }}>
            <ResponsiveImage
              alt='Chi siamo SmartCaf'
              src={webAssets.aboutUs1}
              width={552}
              height={416}
            />
          </Col>
        </Row>

        <div className='mt-24 xl:-mt-16'>
          <div className='flex items-center gap-8 mb-24'>
            <Crown style='w-32' />
            <h2 className='text-[1.75rem] text-green font-semibold mb-0'>
              CHI SIAMO
            </h2>
          </div>

          <p className='text-dimmed text-xl font-light leading-8 mb-16'>
            Al centro di SmartCAF c&apos;è un team giovane, multietnico e coeso
            che condivide un obiettivo comune: offrire servizi di assistenza
            fiscale rapidi, professionali e di alta qualità.
          </p>

          <p className='text-dimmed text-xl font-light leading-8'>
            Ogni membro del nostro team porta con séuna vasta gamma di
            competenze e prospettive, consentendoci di fornire soluzioni
            innovative e personalizzate per le esigenze dei nostri clienti.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutUsIntro
